export const encodeS3Url = (url: string) => {
    try {
        const u = new URL(url);

        // ONLY fix + → %2B
        u.pathname = u.pathname.replace(/\+/g, "%2B");

        return u.toString();
    } catch {
        return url;
    }
};